import { Component, Element, h, Prop, Watch } from '@stencil/core';
import { replaceCheckmarkIcons } from '../../global/utility/utils';

interface UiCmsLegalNoticeDialogBody {
  content: string;
  headline: string;
}

@Component({
  tag: 'ui-cms-legal-notice-dialog',
  styleUrl: 'ui-cms-legal-notice-dialog.scss',
})
export class UiCmsLegalNoticeDialog {
  @Element() el: HTMLUiCmsLegalNoticeDialogElement;

  @Prop({ mutable: true }) body: UiCmsLegalNoticeDialogBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) i18n: { [key: string]: string } = { acceptDisclaimer: 'Alles akzeptieren' };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  dialogRef: any;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Watch('utilityI18n')
  i18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  /**
   Checks if a given date is older than 3 months from the current date.
   @param {string} dateString - The date string to compare.
   @returns {boolean} Returns true if no date exists or the date is older than 3 months, false otherwise.
   */
  olderThan3Months(dateString) {
    if (!dateString) return true;

    const currentDate = new Date();
    const inputDate = new Date(dateString);
    const diffYears = currentDate.getUTCFullYear() - inputDate.getUTCFullYear();
    const diffMonths = diffYears * 12 + (currentDate.getUTCMonth() - inputDate.getUTCMonth());

    return diffMonths > 3;
  }

  /**
   Handles the acceptance of the legal notice.
   Sets the legal notice acceptance date in the local storage and closes the dialog.
   @returns {void}
   */
  handleAccept = () => {
    const legalNoticeAcceptDate = new Date().toISOString();
    localStorage.setItem('legalNoticeAcceptDate', legalNoticeAcceptDate);
    this.dialogRef.hide();
  };

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.i18nChangeHandler(this.utilityI18n);
  }

  componentDidLoad() {
    this.dialogRef.show();
    replaceCheckmarkIcons(this.el);
  }

  render() {
    const { headline, content } = this.body;
    const legalNoticeAcceptDate = localStorage.getItem('legalNoticeAcceptDate');

    // return the dialog if the date of acceptance is more than 3 months old or does not yet exist otherwise return nothing
    return this.olderThan3Months(legalNoticeAcceptDate) ? (
      <sd-dialog
        ref={(el) => {
          this.dialogRef = el;
        }}
        no-close-button
        headline={headline}
      >
        <p class="sd-paragraph" innerHTML={content}></p>
        <sd-button slot="footer" variant="cta" onClick={() => this.handleAccept()}>
          {this.i18n.acceptDisclaimer}
        </sd-button>
      </sd-dialog>
    ) : null;
  }
}
